<template>
  <div class="header">
    <PartnerIcons icon="address" classes="text-primary mr-4" @click="setCurrentLocation"/>
    <span class="header__text" @click="setCurrentLocation">Use My Current Location</span>
  </div>
</template>
<script>
import PartnerIcons from '../Icons/PartnersIcons.vue'
import mixins from '../../config/mixins'
export default {
  mixins: [mixins.location],
  props: {
    route: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PartnerIcons
  },
  data () {
    return {
      savedLocations: []
    }
  },
  mounted () {
    this.fetchSavedLocations()
  },
  methods: {
    async fetchSavedLocations() {
      const response = await this.$http.get('user/address')
      this.savedLocations = response.data
    },
    setCurrentLocation () {
      this.$setState('setIsCurrent', true)
      this.$store.commit("setAnotherLocation", null)
      const isAddressComponents = this.route
      isAddressComponents && this.getLocation(isAddressComponents)
      if(this.route) return //stay on add location form
      this.$store.commit('setPostsFlag', true)
      this.$getState('userLocation') ?  this.setPrimaryLocation() : this.getLocation()
    },
    async setPrimaryLocation () {
      this.$setState('load', 1)
      const obj = this.savedLocations.find(s => s.address == this.$getState('userAddress'))
      const result = obj && obj.id ? await this.setPrimary(obj) : await this.createLocation()
      this.$setState('setIsCurrent', false)
      result.status && setTimeout(this.finish, 1000)
    },
    async setPrimary (obj) {
      return  await this.$http.put(`user/address/${obj.id}`, {...obj, is_primary: 1})
      
    },
    async createLocation () {
      const payload = {
        title: 'Current Location',
        address: this.$getState('userAddress'),
        is_primary: 1,
        ...this.$getState('userLocation')
      }
      return await this.$http.post(`user/address`, payload)
    },
    finish () {
      this.$setState('load', 0)
      this.$router.push(`/${this.$getState('from')}`)
      setTimeout(() => {
        var destination = document.getElementById('post')
        destination.scrollIntoView({
          behavior: 'smooth'
        });
      }, 1000)
    }
  },
  watch: {
    '$store.state.userAddress': {
      immediate: true, 
      deep: true,
      handler (data) {
        if(data && this.$getState('isCurrent') && !this.route) this.setPrimaryLocation()
      }
    }
  }
}
</script>